import React from 'react'
import { useNavigate } from 'react-router-dom';
import './landing.css';

export const Landing = () => {
    const navigate = useNavigate();

    const handleLogin = () => {
        localStorage.removeItem('finanAuth');
        navigate('/auth/login');
    };

    const handleRegister = () => {
        localStorage.removeItem('finanAuth');
        navigate('/auth/register');
    };

    return (
        <div className="landing-page">
            <div className="background-decoration">
                <div className="blob blob-1"></div>
                <div className="blob blob-2"></div>
                <div className="grid-overlay"></div>
            </div>

            <header className="container">
                <div className="header-bar reveal">
                    <div className="brand">
                        <img src="assets/logo/logo-full.png" alt="Logo Bradev" loading="lazy" />
                    </div>
                    <nav className="header-nav">
                        <button 
                            type="button"
                            className="btn btn-ghost" 
                            onClick={handleLogin}
                        >
                            <span className="btn-text">Iniciar Sesión</span>
                        </button>
                        <button 
                            type="button"
                            className="btn btn-primary" 
                            onClick={handleRegister}
                        >
                            <span className="btn-text">Comenzar ahora</span>
                        </button>
                    </nav>
                </div>
            </header>

            <main className="container">
                <section className="hero">
                    <div className="hero-content reveal delay-1">
                        <div className="badge">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M8 1L10.5 6L16 6.5L12 10.5L13 16L8 13L3 16L4 10.5L0 6.5L5.5 6L8 1Z" fill="currentColor"/>
                            </svg>
                            <span>Sistema de soporte profesional</span>
                        </div>
                        <h1>
                            Gestión de Tickets
                            <span className="gradient-text"> de última generación</span>
                        </h1>
                        <p className="hero-description">
                            Administra solicitudes, organiza tu equipo de soporte y resuelve incidencias 
                            con eficiencia usando nuestra plataforma inteligente y fácil de usar.
                        </p>
                        <div className="cta-group">
                            <button 
                                type="button"
                                className="btn btn-primary btn-large" 
                                onClick={handleRegister}
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 2L12.5 7.5L18 8L14 12.5L15 18L10 15L5 18L6 12.5L2 8L7.5 7.5L10 2Z" fill="currentColor"/>
                                </svg>
                                <span className="btn-text">Comenzar gratis</span>
                            </button>
                            <button 
                                type="button"
                                className="btn btn-outline btn-large" 
                                onClick={handleLogin}
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M8 10L10 12L12 10M10 6V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <span className="btn-text">Ver demo en vivo</span>
                            </button>
                        </div>
                        <div className="stats">
                            <div className="stat-item">
                                <div className="stat-value">99.9%</div>
                                <div className="stat-label">Uptime</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-value">2500+</div>
                                <div className="stat-label">Empresas</div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-value">24/7</div>
                                <div className="stat-label">Soporte</div>
                            </div>
                        </div>
                    </div>

                    <div className="hero-visual reveal delay-2">
                        <div className="feature-card glass">
                            <div className="feature-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h3>Gestión centralizada</h3>
                                <p>Todos tus tickets en un solo lugar</p>
                            </div>
                        </div>
                        <div className="feature-card glass">
                            <div className="feature-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M13 10V3L4 14H11V21L20 10H13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h3>Automatización IA</h3>
                                <p>Asignación inteligente de tickets</p>
                            </div>
                        </div>
                        <div className="feature-card glass">
                            <div className="feature-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 19V6M15 19V13M3 12L12 3L21 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <h3>Analytics en tiempo real</h3>
                                <p>Métricas detalladas de rendimiento</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="features" className="features-section reveal delay-3">
                    <div className="section-header">
                        <h2>Todo lo que necesitas para un soporte excepcional</h2>
                        <p>Herramientas potentes diseñadas para equipos modernos</p>
                    </div>
                    <div className="grid">
                        <div className="card">
                            <div className="card-icon">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <rect x="4" y="4" width="24" height="24" rx="4" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M12 16L14 18L20 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <span className="pill">Eficiente</span>
                            <h3>Automatización inteligente</h3>
                            <p>
                                Asigna tickets automáticamente según prioridad, categoría y disponibilidad del equipo
                            </p>
                        </div>
                        <div className="card">
                            <div className="card-icon">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <circle cx="12" cy="10" r="4" stroke="currentColor" strokeWidth="2"/>
                                    <circle cx="20" cy="22" r="4" stroke="currentColor" strokeWidth="2"/>
                                    <path d="M14 12L18 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                            </div>
                            <span className="pill">Colaborativo</span>
                            <h3>Trabajo en equipo</h3>
                            <p>
                                Facilita la comunicación entre agentes y clientes con hilos de conversación integrados
                            </p>
                        </div>
                        <div className="card">
                            <div className="card-icon">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M4 24L8 16L12 20L16 8L20 16L24 12L28 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <span className="pill">Potente</span>
                            <h3>Analytics avanzado</h3>
                            <p>
                                Obtén insights valiosos con reportes detallados y métricas de rendimiento del equipo
                            </p>
                        </div>
                    </div>
                </section>

                <section className="cta-final">
                    <div className="cta-final-content">
                        <h2>¿Listo para transformar tu soporte?</h2>
                        <p>
                            Únete a más de 2,500 equipos que ya están mejorando su eficiencia y satisfacción del cliente
                        </p>
                        <button 
                            type="button"
                            className="btn btn-primary btn-large" 
                            onClick={handleRegister}
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M10 2C5.58 2 2 5.58 2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2ZM13 11H11V13H9V11H7V9H9V7H11V9H13V11Z" fill="currentColor"/>
                            </svg>
                            <span className="btn-text">Crear cuenta gratis</span>
                        </button>
                        <p className="cta-footer-note">Sin tarjeta de crédito • Configuración en 2 minutos</p>
                    </div>
                </section>
            </main>

            <footer className="container">
                <p>&copy; 2026 Bradev. Todos los derechos reservados.</p>
            </footer>
        </div>
    )
}
